export enum BasicStatus {
	DISABLE = 0,
	ENABLE = 1,
}

export enum StorageEnum {
	UserToken = "token",
	Settings = "settings",
	I18N = "i18nextLng",
	TokenExpire = "TokenExpire",
	RefreshToken = "refreshToken",
	RefreshTokenExpire = "RefreshTokenExpire",
	LotteryTourViewed = "lottery_tour_viewed",
}

export enum ThemeMode {
	Light = "light",
	Dark = "dark",
}

export enum ThemeLayout {
	Vertical = "vertical",
	Horizontal = "horizontal",
	Mini = "mini",
}

export enum ThemeColorPresets {
	Default = "default",
	// Cyan = "cyan",
	// Purple = "purple",
	// Blue = "blue",
	// Orange = "orange",
	// Red = "red",
}

export enum LocalEnum {
	en_US = "en_US",
	zh_CN = "zh_CN",
}

export enum MultiTabOperation {
	FULLSCREEN = "fullscreen",
	REFRESH = "refresh",
	CLOSE = "close",
	CLOSEOTHERS = "closeOthers",
	CLOSEALL = "closeAll",
	CLOSELEFT = "closeLeft",
	CLOSERIGHT = "closeRight",
}

export enum PermissionType {
	GROUP = 0,
	CATALOGUE = 1,
	MENU = 2,
	COMPONENT = 3,
}

export enum HtmlDataAttribute {
	ColorPalette = "data-color-palette",
	ThemeMode = "data-theme-mode",
}
